module.exports = __webpack_public_path__ + "static/media/oval_diamond.ec1339ef.png";